const TAB_ITEMS = [
  { id: "password", label: "Change Password" },
  { id: "security", label: "Change Your Security Question" },
  { id: "email", label: "Change Your Email Preferences" },
  { id: "mfa", label: "Multi-Factor Authentication" },
];

const UserProfileNav = ({ activeTab, onTabChange, tabs = TAB_ITEMS }) => {
  return (
    <ul className="user-profile-nav nav nav-pills nav-stacked">
      {tabs.map((item) => (
        <li key={item.id} className={activeTab === item.id ? "active" : ""}>
          <button
            type="button"
            className="user-profile-nav-button"
            onClick={() => onTabChange(item.id)}
          >
            {item.label}
          </button>
        </li>
      ))}
    </ul>
  );
};

export default UserProfileNav;
